export default {
  endpoints: {
    stitchBackend: "https://api.staging.withstitch.com",
  },
  debug: false,
};
